<template>
  <div>
    <!-- Header -->
    <list-header title="Select Outlet" />

    <!-- Select Branch -->
    <div class="mb-3" v-if="selectedBranch !== undefined">
      <div v-for="branch in branches" :key="branch.id">
        <div
          :class="[
            'd-flex text-start align-items-center py-3 scss-click-effect style-branch',
            {
              'style-selected-branch': selectedBranch.id === branch.id,
            },
          ]"
          @click="updateBranch(branch)"
        >
          <div class="container-fluid">
            <div class="row">
              <label class="d-flex flex-row">
                <div class="col-10 scss-clickable">
                  <div
                    v-if="branch.name"
                    class="d-flex flex-column text-start flex-grow-1"
                  >
                    <span class="scss-large-font">{{ branch.name }}</span>
                    <span class="scss-small-font">{{
                      `${branch.addressStreet} ${branch.addressCity} ${branch.addressPostcode} ${branch.addressState} ${branch.addressCountry}`
                    }}</span>
                  </div>
                </div>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-else>
      <item-not-found message="No more outlet found." />
    </div>
  </div>
</template>

<script>
import {
  mapGetters,
  mapActions,
} from "vuex";

import ListHeader from "../../../components/ListHeader.vue";
import ItemNotFound from "@/components/ItemNotFound.vue";
import { getToken } from "@/services/jwtService";
import { saveLoginBranch } from "@/services/loginBranch";
import {
  setAccessTimestamp,
  getIntentRoute,
  removeIntentRoute
} from "@/services/accessTracking";

export default {
  name: "SelectBranch",
  components: { ListHeader, ItemNotFound },
  computed: {
    ...mapGetters(["branches", "selectedBranch"]),
  },
  emits: ["update:branch"],
  methods: {
    updateBranch(branch) {
      const isLogin = getToken();
      const isSameBranch = this.selectedBranch.id === branch.id;
      this.updateSelectedBranch(branch);
      if (isLogin) {
        saveLoginBranch(branch);
      }

      setAccessTimestamp(new Date().toISOString());

      let intentRoute = getIntentRoute();
      if ( // if there is intentRoute(user intention go to route) & if the select branch still same as last access branch
        intentRoute &&
        isSameBranch
      ) {
        this.$router.push(intentRoute);
      } else { // every other scenario, redirect to homepage
        this.goToHomePage();
      }

      removeIntentRoute();
      this.$emit("update:branch");
    },
    goToHomePage() {
      this.$router.push("/home");
    },
    ...mapActions(["updateSelectedBranch"]),
  },
};
</script>

<style lang="scss" scoped>
.style-branch {
  margin-bottom: 10px;
  border-radius: 3px;
  box-shadow: 0 2px 5px #c3c3c3;
}
.style-selected-branch {
  background-color: $text-blue;
  color: $light-grey;
}
</style>
